import { QuoteModeEnum } from "../enums/quote-create.enums";
import { mapPaymentMethodsToBackend } from "./mapPaymentMethodsToBackend";

interface BuildQuotePayloadArgs {
  mode: QuoteModeEnum;
  basicQuotes: any[];
  advancedQuotes: any[];
  clientSelection: any;
  requiredSign: boolean;
  alias?: string;
  depositAmount?: number | null;
  depositPercent?: number | null;
  paymentMethod: any;
  depositRequired: boolean;
}

export const buildQuotePayload = ({
  mode,
  basicQuotes,
  advancedQuotes,
  clientSelection,
  alias,
  requiredSign,
  depositAmount,
  depositPercent,
  paymentMethod,
  depositRequired,
}: BuildQuotePayloadArgs) => {
  if (!clientSelection?.uid) {
    throw new Error("clientSelection.uid es requerido");
  }

  if (!clientSelection?.coverageArea?.id) {
    throw new Error("clientSelection.coverageArea.id es requerido");
  }

  const client = {
    clientUid: clientSelection.uid,
    coverageAreaId: clientSelection.coverageArea.id,
  };

  const paymentMethods = depositRequired
    ? mapPaymentMethodsToBackend({
        selectedPayments: paymentMethod.selectedPayments,
        referenceNumber: paymentMethod.referenceNumber,
        markAsPaid: paymentMethod.markAsPaid,
        manualEntryNotes: paymentMethod.manualEntryNotes,
        manualEntryTransactionId: paymentMethod.manualEntryTransactionId,
      })
    : undefined;

  const basePayload = {
    contractStatus: "sent",
    payment: {
      paymentRequired: false,
    },
    client,
    alias,
    requiredSign,
    depositAmount,

    ...(depositPercent != null && Number(depositPercent) > 0
      ? {
          depositPercent: Number(depositPercent),
        }
      : {}),

    ...(depositRequired && paymentMethods?.length ? { paymentMethods } : {}),
  };

  if (mode === QuoteModeEnum.BASIC) {
    const services = basicQuotes.map((svc) => {
      const frequencyType = svc.frequencyType ?? svc.scopeOfWork?.frequencyType ?? "weekly";

      return {
        id: svc.id,
        service: svc.service,
        price: svc.price,
        units: svc.units,
        measure: svc.measure,
        notes: svc.notes,
        alias: svc.alias,
        total: svc.total,
        frequencyType,

        useServiceNameOverride: Boolean(svc.useServiceNameOverride),

        serviceNameOverride: svc.useServiceNameOverride ? svc.serviceNameOverride?.trim() || null : null,

        scopeOfWork: {
          name: svc.service || "Basic Service",

          serviceNameOverride: svc.useServiceNameOverride ? svc.serviceNameOverride?.trim() || null : null,

          averagePeople: 1,
          squareFootage: "0-1000",
          typeOfServiceUid: svc.serviceUid || "",

          typeOfService: {
            costBias: 1,
            baseRatePerHour: typeof svc.price === "number" ? svc.price : Number(svc.price) || 0,
          },
          frequencyType,
        },
      };
    });

    return {
      type: "basic",
      ...basePayload,
      services,
    };
  }

  if (mode === QuoteModeEnum.ADVANCED) {
    const services = advancedQuotes.map((svc) => {
      const serviceNameOverride =
        svc.serviceNameOverride?.trim() || svc.updates?.serviceNameOverride?.trim() || svc.scopeOfWork?.serviceNameOverride?.trim() || null;

      return {
        type: svc.type,
        serviceNameOverride,

        scopeOfWork: {
          ...svc.scopeOfWork,
          serviceNameOverride,
        },

        eventPreferences: svc.eventPreferences,
        alias: svc.updates?.alias || "",
      };
    });

    console.log("[ADVANCED QUOTE SERVICES PAYLOAD]", services);

    return {
      type: "advanced",
      ...basePayload,
      services,
    };
  }

  throw new Error("Modo de cotización inválido");
};
